import React from 'react';
import PropTypes from 'prop-types';
import Story from 'zignal-landscape/lib/Story';
import Link from 'zignal-landscape/lib/Link';
import themeable from 'zignal-landscape/lib/themeable';
import StoryDetails from 'containers/TrendingStoriesOverview/components/StoryDetails';
import ComponentProxy from '../ComponentProxy';

const OverviewPage = ({
  story,
  analytics = null,
  storyDetails = null,
  loadAnalyticsError = null,
  loadOverviewError = null,
  styles,
  timezone = 'EST',
  shortDateString,
  isTwitterRestricted
}) => {

  return (
    <div>
      <div className={styles.storyContainer}>
        <h3 className={styles.tabTitle} data-cy="overviewTabTitle">Overview &nbsp;
          <span className={styles.normalSize}> {shortDateString}</span>
        </h3>
        <Story>
          <Story.Content>
            <ComponentProxy className={styles.largeSize}>
              <Story.Body>
                <ComponentProxy className={styles.storyHeading}>
                  {story.title && (
                    <Story.Headline>
                      {story.titlePrefix && <i style={{ fontWeight: 'normal' }}>{story.titlePrefix}</i>}{story.title}
                    </Story.Headline>
                  )}
                </ComponentProxy>
                {story.body && (
                  <ComponentProxy className={styles.storyBodyWrapper}>
                    <Story.Text lines={3}>
                      {story.body}
                    </Story.Text>
                  </ComponentProxy>
                )}
              </Story.Body>
            </ComponentProxy>
            <Story.Footer>
              <Story.Footer.Item>
                <span className={styles.normalSize}>
                  {story.domain}
                </span>
              </Story.Footer.Item>
              <Story.Footer.Item>
                <Link target="_blank" href={story.link}>
                  <span className={styles.storyLink}>
                    Read on original website
                  </span>
                </Link>
              </Story.Footer.Item>
            </Story.Footer>
          </Story.Content>
        </Story>
      </div>
      <StoryDetails
        storyDetails={storyDetails}
        loadOverviewError={loadOverviewError}
        timezone={timezone}
        loadAnalyticsError={loadAnalyticsError}
        analytics={analytics}
        isTwitterRestricted={isTwitterRestricted}
      />
    </div>
  );
};

OverviewPage.propTypes = {
  story: PropTypes.object.isRequired,
  analytics: PropTypes.object,
  storyDetails: PropTypes.object,
  styles: PropTypes.object.isRequired,
  shortDateString: PropTypes.string,
  loadAnalyticsError: PropTypes.any,
  loadOverviewError: PropTypes.any,
  timezone: PropTypes.string,
  isTwitterRestricted: PropTypes.bool.isRequired
};

export default themeable(OverviewPage);
